<mat-toolbar class="topbar">

  <!-- Mobile Menu -->
  <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex d-md-none justify-content-center">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  <h1>{{pageTitle}}</h1>
  <span class="flex-1-auto"></span>
  <button class="m-l-10" mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications">
    <img src="/assets/images/profile/user-1.jpg" class="rounded-circle object-cover" width="35" />
  </button>
  <mat-menu #profilemenu="matMenu" xPosition="before" class="cardWithShadow">
    <div class="user-profile">
      <div class="user-icon">
        <img src="/assets/images/profile/user-1.jpg" class="rounded-circle object-cover" width="80" />
      </div>
      <div class="user-details">
        <h4 title="{{userInfo?.full_name}}">{{userInfo?.full_name}}</h4>
        <h5 title="{{userInfo?.primary_email_id}}">{{userInfo?.primary_email_id}}</h5>
        <h5>{{userInfo?.phone_number}}</h5>
      </div>
    </div>
    <a [routerLink]="['/home/'+GlobalContants.Routes.Profile]" routerLinkActive="router-link-active"  mat-menu-item>
      <mat-icon class="d-flex align-items-center"><i-tabler name="user" class="icon-18 d-flex"></i-tabler></mat-icon>
      Profile
    </a>
    <a [routerLink]="['/home/'+GlobalContants.Routes.ChangePassword]" routerLinkActive="router-link-active" mat-menu-item>
      <mat-icon class="d-flex align-items-center"><i-tabler name="mail" class="icon-18 d-flex"></i-tabler></mat-icon>
      Change Password
    </a>
   
    <div class="p-x-12 m-t-12">
      <a (click)="logout()" mat-stroked-button color="primary" class="w-100">Logout</a>
    </div>
  </mat-menu>
</mat-toolbar>